export const gameName = 'colorwheel';
export const socketGamePath = 'game';
